import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const TestModeBanner = () => {
  const isProd = process.env.NODE_ENV === "production" ;
  if (isProd) return null;

  console.log(`Adding TestModeBanner for NODE_ENV ${process.env.NODE_ENV}`)
  return (
    <Box
      sx={{
        position: "fixed",
        top: 24,
        left: -48,
        transform: "rotate(-45deg)",
        zIndex: (theme) => theme.zIndex.tooltip + 10,
        pointerEvents: "none", // ensures no UI blocking
      }}
    >
      <Typography
        variant="caption"
        sx={(theme) => ({
          backgroundColor: alpha(theme.palette.error.main, 0.7),  // 70% opacity
          color: "error.contrastText",
          backdropFilter: "blur(2px)", // subtle glass effect
          px: 6,
          py: 0.25,
          letterSpacing: 1,
          boxShadow: 1,
        })}
      >
        TEST MODE
      </Typography>
    </Box>
  );
};

export default TestModeBanner;
